import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const getCrmConfigsByProjectId = async (
  crmProjectId: Tables<"crm_project">["id"]
) => {
  const res = await supabase
    .from("crm_config")
    .select("*, crm(*,organisation_crm(*)), crm_project(*)")
    .eq("crm_project_id", crmProjectId)
    .throwOnError();
  return res.data;
};
